/* Ao Criar um novo perfil, a chave do perfil deve ser igual ao codigo do perfil */

export default {
  ARRECADACAO: {
    CODIGO_MODULO: 'ARRECADACAO',
    TITULO_MODULO: 'SiCARF - Arrecadação',
    GERENTE_COF: {
      codigo: 'GERENTE_COF',
      home: '/arrecadacao/cof/home'
    },
    GERENTE_GAT: {
      codigo: 'GERENTE_GAT',
      home: '/arrecadacao/gat'
    },

    ANALISTA_GAT: {
      codigo: 'ANALISTA_GAT',
      home: '/arrecadacao/gat/home'
    },

    COORDENADOR_CAF_ARRECADACAO: {
      codigo: 'COORDENADOR_CAF_ARRECADACAO',
      home: '/arrecadacao/caf'
    },

    PRESIDENTE_CPAT: {
      codigo: 'PRESIDENTE_CPAT',
      home: '/arrecadacao/cpat'
    },

    ANALISTA_CPAT: {
      codigo: 'ANALISTA_CPAT',
      home: '/arrecadacao/cpat'
    },

    ADMINISTRATIVO_S1_ARRECADACAO: {
      codigo: 'ADMINISTRATIVO_S1_ARRECADACAO',
      home: '/arrecadacao/gp'
    },

    PRESIDENTE_GP_ARRECADACAO: {
      codigo: 'PRESIDENTE_GP_ARRECADACAO',
      home: '/arrecadacao/gp'
    },

    GERENTE_GDA_ARRECADACAO: {
      codigo: 'GERENTE_GDA_ARRECADACAO',
      home: '/arrecadacao/gda'
    },

    RELATORIOS_ARRECADACAO: {
      codigo: 'RELATORIOS_ARRECADACAO',
      home: '/arrecadacao/relatorios'
    },

    GERENTE_ARRECADACAO: {
      codigo: 'GERENTE_ARRECADACAO',
      home: '/arrecadacao/gda'
    }
  },

  FINANCEIRO: {
    CODIGO_MODULO: 'FINANCEIRO',
    COORDENADOR_COF: {
      codigo: 'COORDENADOR_COF',
      home: '/financeiro/home'
    },
    ANALISTA_COF: {
      codigo: 'ANALISTA_COF',
      home: '/financeiro/home'
    },
    FINANCEIRO: {
      codigo: 'FINANCEIRO',
      home: '/financeiro/home'
    }
  },
  ANALISE: {
    CODIGO_MODULO: 'ANALISE',
    ANALISE: {
      codigo: 'ANALISE',
      home: '/analise'
    }
  },
  CENTRAL_DO_INTERESSADO: {
    CODIGO_MODULO: 'CENTRAL_DO_INTERESSADO',
    EXTERNO: {
      codigo: 'EXTERNO',
      home: '/central/home'
    },
    PREFEITURA: {
      codigo: 'PREFEITURA',
      home: '/central/home'
    },
    CONSULTOR_EXTERNO: {
      codigo: 'CONSULTOR_EXTERNO',
      home: '/central/home'
    },
    CONSULTOR_EXTERNO_DIVERSOS: {
      codigo: 'CONSULTOR_EXTERNO_DIVERSOS',
      home: '/central/home'
    }
  },

  ASSINATURA: {
    CODIGO_MODULO: 'ASSINATURA',
    TITULO_MODULO: 'SiCARF - Assinatura',
    ASSINADOR: {
      codigo: 'ASSINADOR',
      home: '/assinatura/home'
    }
  },
  RECEPTOR: {
    CODIGO_MODULO: 'RECEPTOR',
    TITULO_MODULO: 'SiCARF - Receptor',
    RECEPTOR: {
      codigo: 'RECEPTOR',
      home: '/receptor'
    },
    RECEPTOR_EXTERNO: {
      codigo: 'RECEPTOR_EXTERNO',
      home: '/receptor'
    }
  },
  DIAGNOSTICO: {
    CODIGO_MODULO: 'DIAGNOSTICO',
    TITULO_MODULO: 'Diagnóstico de uso e cobertura do solo',
    DIAGNOSTICO: {
      codigo: 'DIAGNOSTICO',
      home: '/diagnostico'
    }
  },
  GESTAO_DE_DEMANDAS: {
    CODIGO_MODULO: 'GESTAO_DE_DEMANDAS',
    TITULO_MODULO: 'SiCARF - Gestão de demandas',
    GESTOR_DE_DEMANDAS: {
      codigo: 'GESTOR_DE_DEMANDAS',
      home: '/demandas/home'
    }
  },
  RELATORIOS: {
    CODIGO_MODULO: 'RELATORIOS',
    TITULO_MODULO: 'Relatórios',
    RELATORIOS: {
      codigo: 'RELATORIOS',
      home: 'relatorios/home'
    }
  },
  MANUTENCAO: {
    CODIGO_MODULO: 'MANUTENCAO',
    TITULO_MODULO: 'Manutenção',
    MANUTENCAO: {
      codigo: 'MANUTENCAO',
      home: '/manutencao'
    }
  },
  CADASTRANTE: {
    CODIGO_MODULO: 'CADASTRANTE',
    TITULO_MODULO: 'Cadastrante',
    CADASTRANTE_RF: {
      codigo: 'CADASTRANTE_RF',
      home: '/cadastrante'
    },
    CADASTRANTE_UC: {
      codigo: 'CADASTRANTE_UC',
      home: '/cadastrante'
    }
  },
  BANCO_DADOS: {
    CODIGO_MODULO: 'BANCO_DADOS',
    TITULO_MODULO: 'Banco de dados',
    GLEBA: {
      codigo: 'GLEBA',
      home: '/bancoDados/gleba'
    },
    CONSULTA_PROCESSOS_ANTIGOS: {
      codigo: 'CONSULTA_PROCESSOS_ANTIGOS',
      home: '/bancoDados/consultaProcessosAntigos'
    }
  },
  GESTAO_SICARF: {
    CODIGO_MODULO: 'GESTAO_SICARF',
    TITULO_MODULO: 'Comissão de gestão sicarf',
    COMISSAO_GESTAO_SICARF: {
      codigo: 'COMISSAO_GESTAO_SICARF',
      home: '/gestaoSicarf'
    }
  }
}



// WEBPACK FOOTER //
// ./src/constants/perfil.js